export default __webpack_public_path__ + "images/1cd3b61adcdfb0c1b5124c5014515855.svg";